import React from "react";
import {
  startOfWeek,
  addDays,
  addWeeks,
  startOfMonth,
  endOfMonth,
  addMonths,
  subDays,
} from "date-fns";
import { formatDateForAPI } from "utils/utils";
import { EvtSelect } from "components/index";

const OPTIONS = [
  { id: "this_week", name: "This week" },
  { id: "next_week", name: "Next week" },
  { id: "this_month", name: "This month" },
  { id: "next_month", name: "Next month" },
  { id: "last_7_days", name: "Last 7 days" },
];

export function RangePresetFilter({ filters, setFilters }) {
  const preset = filters?.rangePreset || "this_week";

  const applyPreset = (key) => {
    const today = new Date();
    let from, to;
    switch (key) {
      case "last_7_days": {
        from = subDays(today, 7);
        to = subDays(today, 1);
        break;
      }
      case "next_week": {
        const weekStart = startOfWeek(addWeeks(today, 1), { weekStartsOn: 1 });
        from = weekStart;
        to = addDays(weekStart, 4); // Friday
        break;
      }
      case "this_month": {
        const s = startOfMonth(today);
        from = s;
        to = endOfMonth(today);
        break;
      }
      case "next_month": {
        const next = addMonths(today, 1);
        from = startOfMonth(next);
        to = endOfMonth(next);
        break;
      }
      case "this_week":
      default: {
        const weekStart = startOfWeek(today, { weekStartsOn: 1 });
        from = weekStart;
        to = addDays(weekStart, 4); // Friday
        break;
      }
    }

    setFilters({
      ...filters,
      rangePreset: key,
      startDate: formatDateForAPI(from),
      endDate: formatDateForAPI(to),
    });
  };

  return (
    <EvtSelect
      showClearButton={false}
      type="filter"
      value={preset}
      onChange={applyPreset}
      data={OPTIONS}
      placeholder="Select range"
      className="h-9 w-80"
    />
  );
}
